import DefaultAuthSection from './DefaultAuthSection';
import GitHubAuthSection from './GitHubAuthSection';
import { AuthSectionProps } from './types';

const providerAuthComponents: Record<
  string,
  (props: AuthSectionProps) => React.ReactNode
> = {
  GitHub: GitHubAuthSection,
  GitLab: DefaultAuthSection,
  Bitbucket: DefaultAuthSection,
};

const AuthSection = ({ selectedGitProvider, ...props }: AuthSectionProps) => {
  const AuthComponent =
    providerAuthComponents[selectedGitProvider || ''] || DefaultAuthSection;
  return <AuthComponent selectedGitProvider={selectedGitProvider} {...props} />;
};

export default AuthSection;
